import { Box, Button, Flex, Text } from "@chakra-ui/react";
import type { Paginated } from "../../types/axios.types";
import type { ReactNode } from "react";
import type { UseInfiniteQueryResult } from "react-query";

export type ServerSideListElementProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	data: any;
};

export type ServerSideListProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	query: UseInfiniteQueryResult<Paginated<any[]>, unknown>;
	template: (props: ServerSideListElementProps) => ReactNode;
	templateEmpty?: () => ReactNode;
	cardProps?: (props: ServerSideListElementProps) => object;
};

const ServerSideList = ({
	query,
	template,
	templateEmpty,
	cardProps,
}: ServerSideListProps) => {
	const label = "TYPE";
	const response = query;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const dataToProps = (data: any) => {
		return {
			data,
		};
	};

	const items =
		response?.data?.pages?.flatMap((page) => page?.data ?? []) ?? [];
	const isEmpty = !response?.isLoading && items.length === 0;
	return (
		<Flex w="100%" justify="center" direction="column" alignItems="center">
			<Box w="100%" borderRadius="xl" backgroundColor="zinc.50" py="3px">
				<Flex px="24px" py="12px">
					<Text color="gray.500">{label}</Text>
				</Flex>

				<Box>
					{items.map((element) => (
						<Box
							key={element.id}
							backgroundColor="white"
							boxShadow="sm"
							p="24px"
							m="3px"
							_first={{
								borderTopRadius: "md",
							}}
							_last={{
								borderBottomRadius: "md",
							}}
							{...(cardProps ? cardProps(dataToProps(element)) : {})}
						>
							{template(dataToProps(element))}
						</Box>
					))}
					{isEmpty &&
						(templateEmpty ? (
							templateEmpty()
						) : (
							<Flex
								direction="column"
								justify="center"
								alignItems="center"
								backgroundColor="white"
								borderRadius="xl"
								p="24px"
								m="4px"
								h="min(40vh, 400px)"
							>
								<Text
									lineHeight="30px"
									fontSize="20px"
									fontWeight="600"
									color="gray.900"
								>
									Pas de donnée trouvée
								</Text>
								<Text
									lineHeight="30px"
									fontSize="12px"
									fontWeight="200"
									color="gray.400"
								>
									Vous pouvez essayer avec une autre recherche
								</Text>
							</Flex>
						))}
				</Box>
				{response?.hasNextPage && (
					<Flex justify="center" py="12px">
						<Button
							size="sm"
							variant="outline"
							onClick={() => {
								if (!response?.hasNextPage) return;
								if (response?.isFetchingNextPage) return;
								response.fetchNextPage();
							}}
							isLoading={response?.isFetchingNextPage}
							loadingText="Chargement..."
						>
							Voir plus
						</Button>
					</Flex>
				)}
			</Box>
		</Flex>
	);
};

export default ServerSideList;
